/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { Dropdown, Accordion, Form } from 'react-bootstrap'
import './DropdownFilter.css'

type FilterSelection = Record<string, string[]>

type Props = {
  filters: Record<string, string[]>
  onFilterChange: (selectedFilters: FilterSelection) => void
  filterLabels?: Record<string, string>
  filterOptions?: Record<string, string[]>
  buttonLabel?: string
}

const DropdownFilter: React.FC<Props> = ({
  filters,
  onFilterChange,
  filterLabels = {},
  filterOptions,
  buttonLabel = 'Filter',
}) => {
  const [selectedFilters, setSelectedFilters] = useState<FilterSelection>({})

  const handleCheckboxChange = (category: string, value: string): void => {
    setSelectedFilters((prevFilters) => {
      const currentSelections = prevFilters[category] || []
      const newSelections = currentSelections.includes(value)
        ? currentSelections.filter((item) => item !== value)
        : [...currentSelections, value]

      const updatedFilters = { ...prevFilters, [category]: newSelections }
      onFilterChange(updatedFilters)
      return updatedFilters
    })
  }

  const optionsToUse = filterOptions ?? filters

  return (
    <Dropdown>
      <Dropdown.Toggle className="filter-btn">{buttonLabel}</Dropdown.Toggle>
      <Dropdown.Menu className="filter-dropdown">
        <Accordion>
          {Object.keys(optionsToUse).map((key) => (
            <Accordion.Item eventKey={key} key={key}>
              <Accordion.Header>{filterLabels[key] || key}</Accordion.Header>
              <Accordion.Body>
                {(optionsToUse[key] || []).map((option) => (
                  <Form.Check
                    key={option}
                    type="checkbox"
                    label={option}
                    checked={(selectedFilters[key] || []).includes(option)}
                    onChange={() => handleCheckboxChange(key, option)}
                  />
                ))}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DropdownFilter
